<template>
		<div class="contact container">
			<h1 class="section__heading contact__heading">{{ contactTitle }}</h1>
				<form class="contact__form"
							name="contact"
							method="post"
							action="/success"
							data-netlify="true"
							data-netlify-honeypot="bot-field"
				>
					<input type="hidden" name="form-name" value="contact" />
					<p hidden>
						<label>Don’t fill this out: <input name="bot-field" /></label>
					</p>
					<div v-for="element in (contact.formFields || [])"
								 class="contact__element">
						<formTextInput v-if="element._type === 'textInput'" :content="element" />
						<formTextareaInput v-else-if="element._type === 'textareaInput'" :content="element" />
						<formSubheader v-else-if="element._type === 'localeString'" :content="element" />
						<formSelectInput v-else-if="element._type === 'selectInput'" :content="element" />
						<formCheckboxGroup v-else-if="element._type === 'checkboxGroup'" :content="element" />
						<formRadioGroup v-else-if="element._type === 'radioGroup'" :content="element" />
						<formSelectInput v-else :content="element" />
					</div>
					<button type="submit" class="contact__button">Submit</button>
				</form>
		</div>
</template>

<script setup>
import { useI18n } from '#imports'
import {useHead} from "nuxt/app";
import {computed} from "vue";
const query = groq`{
    'contact': *[_type == 'contact']{
        title,
        metaTitle,
        metaDescription,
        formFields[]{
           ...
        }
    }
  }`;
const sanity = useSanity()
const { data } = await useAsyncData('page:contact', () => sanity.fetch(query))
const contact = computed(() => data.value?.contact?.[0] ?? {})
const { locale } = useI18n()
const htmlLang = computed(() => locale.value === 'en' ? 'en-US' : 'ja-JA')
const contactTitle = computed(() => locale.value === 'en' ? contact.value?.title?.en : contact.value?.title?.jp)
const processedTitle = computed(() => locale.value === 'en'
	? `TokyoDex - ${contact.value?.title?.en || 'Contact'}`
	: `TokyoDex - ${contact.value?.title?.jp || 'お問い合わせ'}`
)
const processedDescription = computed(() => locale.value === 'en'
	? `TokyoDex - ${contact.value?.title?.en || 'Contact'}`
	: `TokyoDex - ${contact.value?.title?.jp || 'お問い合わせ'}`
)
useHead({
  htmlAttrs: {
    lang: htmlLang
  },
  title: processedTitle,
  viewport: 'width=device-width, initial-scale=1, maximum-scale=1',
  charset: 'utf-8',
  meta: [
    { name: 'description', content: processedDescription }
  ],
})
</script>

<style lang="scss" scoped>
	@use '@/assets/sass/variables.scss' as v;
  .contact {
    margin: 10rem auto 0 auto;
    width: 55rem;
    &__heading {
      margin: 0 0 2rem 0;
    }
    &__text {
      margin: 0 0 3rem 0;
			position: relative;
      width: 100%;
			&.populated, &:focus-within {
				label {
					background-color: v.$white;
					font-size: 0.9rem;
					padding: 0 0.5rem;
					transform: translateY(-0.75rem);
					transition: 0.3s;
				}
			}
      label {
        display: inline-block;
				left: 0.5rem;
				padding: 0.85rem;
				position: absolute;
				transition: 0.3s;
      }
      input, textarea {
        border: 0.05rem solid v.$lightGrey;
        display: block;
				padding: 1rem;
				transition: 0.3s;
        width: 100%;
				&:focus {
					border: 0.05rem solid v.$teal;
					box-shadow: 0 0 7px -3px v.$teal;
					outline: none;
					transition: 0.3s;
				}
      }
    }
		&__checks {
			display: flex;
			flex-wrap: wrap;
			margin: 0 0 3rem 0;
			.contact__subheader {
				width: 100%;
			}
		}

    &__button {
      @include v.button;
			margin: 0;
    }
  }
</style>
